import { combineReducers } from '@reduxjs/toolkit';
import chat from './chatSlice';
import chats from './chatsSlice';
import contacts from './contactsSlice';
import state from './stateSlice';

const reducer = combineReducers({
  contacts,
  chat,
  chats,
  state,
});

export default reducer;
